import {isDevXd}        from "@Common/ui-components/debug/is-dev";
import {setNestedValue} from "@Common/utils/arr-path";

import { formatText } from "../tools/format-text";

import {getBindingResults} from "./get-binding-results";

// bindingData is not mutated
// overrideData is not mutated
// listingData is not mutated
// bindingResults is not mutated
// allItems is MUTATED (in getBoundData, by dropdownItems)
// product is
// templateConfig is not mutated
// customFieldsData is not mutated
export const mapBindingDropdown = async (
    bindingData, overrideData, listingData, bindingResults, allItems, product, templateConfig,
    customFieldsData
) => {
    isDevXd() ? console.log("items", allItems) : null;
    let dropdownItems = allItems.filter((item) => {
        const surfaceName = item.parentContainer.parentComponent.name;
        return (
            (item.type === "BoundedTextItem" || item.type === "PathBoundedTextItem" || item.type === "PlaceholderItem") &&
            bindingData[surfaceName]?.[item.name]?.["type"] === "dropdown"
        );
    });
    let data = await getBoundData(dropdownItems, bindingData, listingData, overrideData, product);
    const customItems = allItems.filter((item) => {
        const surface = item.parentContainer.parentComponent.name;
        return (
            (item.type === "BoundedTextItem" || item.type === "PathBoundedTextItem") &&
            (
                (bindingData?.[surface]?.[item.name]?.["type"] === "customVariable") ||
                (
                    customFieldsData?.[surface]?.some((field) => field.name === item.name) &&
                    bindingData[surface]?.[item.name]?.["type"] !== "dropdown"
                )
            )
        );
    });
    for (let x=0; x<=50; x++) {
        const initData = data;
        if (!bindingResults) {
            bindingResults = data;
        } else {
            Object.entries(data["surfaces"]??{}).forEach(([surface, fields])=>{
                Object.entries(fields).forEach(([field, value])=>{
                    bindingResults = setNestedValue(bindingResults, ["surfaces", surface, field], value);
                })
            });
        }
        let customData = await getCustomBoundData(customItems, bindingData, listingData, bindingResults, templateConfig);

        Object.entries(customData["surfaces"]??{}).forEach(([surface, fields])=>{
            Object.entries(fields).forEach(([field, value])=>{
                data = setNestedValue(data, ["surfaces", surface, field], value);
            })
        });

        //if no changes were made, stop applying binding data
        if (JSON.stringify(initData) === JSON.stringify(data)) {
            break;
        }
    }

    isDevXd() ? console.log("Dropdown Data 1", data) : null;
    return data;
};

// items is MUTATED (item["placeholders"]["_collection"]["0"], item["originalText"])
// bindingData is not mutated
// listingData is not mutated
// overrideData is not mutated
const getBoundData = async (items, bindingData, listingData, overrideData, product) => {
    let boundData = {};
    isDevXd() ? console.log("items", items) : null;
    items?.forEach( (item) => {
        try {
            isDevXd() ? console.log("Dropdown", item): null;
            let itemSurface = item.parentContainer.parentComponent.name;
            const bindingValue = bindingData[itemSurface]?.[item.name];
            if (bindingValue){
                const value = (
                    bindingValue["value"]?.split('\n') ?? [""]
                )
                    .map((value) => (
                        getBindingResults(overrideData, value) ||
                        getBindingResults(listingData, value)
                    ))
                ;

                if (!item['placeholders']['empty']) {
                    let dropdownItem = item['placeholders']['_collection']['0'];
                    if (dropdownItem['values']['0']) {
                        boundData = setNestedValue(boundData, ["surfaces", itemSurface, dropdownItem['name']], value[0]);
                        boundData = setNestedValue(boundData, ["surfaces", itemSurface, item.name], value[0]);
                    }
                } else {
                    let itemId = "[#" + item.name.toUpperCase() + "DROP|" + value.join(';') + "]";
                    item["placeholders"]["_collection"]["0"] = {
                        "values": value,
                        "value": value[0],
                        "name": item.name.toUpperCase() + "DROP",
                        "id": itemId
                    };
                    item["originalText"] = itemId;
                    boundData = setNestedValue(boundData, ["surfaces", itemSurface, `${item.name.toUpperCase()}DROP`], value[0]);
                    boundData = setNestedValue(boundData, ["surfaces", itemSurface, item.name], value[0]);
                    product.setItem(item);
                }
            }
        }
        catch (e){
            console.log("Error with binding dropdown for item: ", item);
            console.log(e);
        }
    });
    return boundData;
};

// items is not mutated
// bindingData is not mutated
// listingData is not mutated
// templateConfig is not mutated
const getCustomBoundData = async (items, bindingData, listingData, bindingResults, templateConfig) => {
    let boundData = {};
    isDevXd() ? console.log("items", items) : null;
    items?.forEach( (item) => {
        try{
            isDevXd() ? console.log("Custom", item): null;
            const itemSurface = item.parentContainer.parentComponent.name;
            let bindingValue = bindingData[itemSurface]?.[item.name]?.["value"];
            const mask = templateConfig[itemSurface]?.[item.name]?.['inputMask'];
            if (bindingValue) {
                bindingValue = getBindingResults({...listingData, ...bindingResults['surfaces']?.[itemSurface]}, bindingValue);
                if ( item?._isRichText ){
                    bindingValue = bindingValue.replace( /&(?!amp;|lt;)/gi, '&amp;').replace( /<(?![^<]*>)/gi, '&lt;');
                }
                boundData = setNestedValue(boundData, ["surfaces", itemSurface, item['name']], formatText(mask, bindingValue));
            }
        }
        catch (e){
            console.log("Error with binding custom variable for item: ", item);
            console.log(e);
        }
    });
    return boundData;
};
